import styles from './OutOfStockDisclaimer.module.css';

export const OutOfStockDisclaimer = ({ className }: { className?: string }) => {
  return (
    <button className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <p>Out of stock</p>
    </button>
  );
};
